import ApiMakerConfig from "@kaspernj/api-maker/build/config"
import {callbacksHandler} from "on-location-changed/build/callbacks-handler"
import currenciesCollection from "shared/currencies-collection"
import env from "shared/env"
import history from "@kaspernj/api-maker/build/history"
import Modal from "components/modal"
/* eslint-disable sort-imports */

// Set global.applicationHistory so that on-location-changed will listen on it
callbacksHandler.connectReactRouterHistory(history)

// Use our own logging tool to log errors when testing
import "shared/error-logger"

const apiUrl = new URL(env.API_URL)
const currentProtocol = globalThis.location?.protocol == "https:" ? "wss:" : "ws:"
const currentCableUrl = `${currentProtocol}//${globalThis.location?.host}/cable`
const cableUrl = globalThis.location?.host == apiUrl.host ? env.API_CABLE_URL : currentCableUrl

// API maker
ApiMakerConfig.setCableUrl(cableUrl)
ApiMakerConfig.setCurrenciesCollection(currenciesCollection)
ApiMakerConfig.setHistory(history)
ApiMakerConfig.setModal(Modal)
ApiMakerConfig.setWebsocketRequests(true)

// Stylesheets
require.context("..", true, /\/(.+)\.(s|)css$/)
require.context("@kaspernj/api-maker/build", true, /\/(.+)\.(s|)css$/)

// React layout and application
import "shared/action-cable-logging"
import "shared/react-native-vector-icons"
import "shared/react-native-web-z-index-fix"
import "shared/source-maps"
import "shared/time-zone-offset"
import "components/play"
import "controllers"
import "stylesheets/application"
import "react-toggle/style"
